import { render, staticRenderFns } from "./SMKItem.vue?vue&type=template&id=54be9aa6&scoped=true&"
import script from "./SMKItem.vue?vue&type=script&lang=js&"
export * from "./SMKItem.vue?vue&type=script&lang=js&"
import style0 from "./SMKItem.vue?vue&type=style&index=0&id=54be9aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54be9aa6",
  null
  
)

export default component.exports